import React from 'react';
import { ReferenceManyField, useListContext, Pagination } from 'react-admin';
import ChargeGrid from '../../charges/components/ChargeGrid';

const ChargeGridWithTotal = props => {
    const { total, loaded } = useListContext();

    return (
        <>
            {loaded && (
                <div
                    style={{
                        padding: '16px',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: 'rgba(0, 0, 0, 0.87)',
                    }}
                >
                    Total Charges: {total || 0}
                </div>
            )}
            <ChargeGrid {...props} hasShow={true} />
            <Pagination />
        </>
    );
};

export const InvoiceChargesList = props => (
    <ReferenceManyField
        reference="charges"
        target="invoiceId"
        filter={{ invoiceId: props.record.id }}
        perPage={25}
        {...props}
    >
        <ChargeGridWithTotal {...props} />
    </ReferenceManyField>
);
